module.exports = __webpack_public_path__ + "img/new-int-f2f.4644914d.svg";